<template>
  <div class="o-card u-padding-xsmall">
    <div class="row s-batteries__drawer-detail">
      <div
        class="es-xs-12 es-sm-4 u-margin-top u-padding-top-xsmall u-radius-g"
        v-for="(feature, i) in features"
        :key="i"
      >
        <h5 class="u-padding-right-xsmall u-padding-left-xsmall">
          {{ feature.localesInfo[$i18n.locale] }}
        </h5>
        <ul
          class="c-list u-margin-top-small u-padding-right-xsmall u-padding-left-xsmall"
        >
          <li
            class="c-list__item u-display-flex u-align-items-center u-justify-content-space-between"
            v-for="(option, j) in feature.options"
            :key="i + '-' + j"
          >
            <span> {{ option.localesInfo[$i18n.locale] }}</span>
            <span>{{ option.value }} {{ option.suffix }}</span>
          </li>
        </ul>
      </div>
      <div
        class="u-background-color-filtered u-margin-top-xsmall es-xs-12 es-sm-8"
        v-for="(feature, i) in result"
        :key="i"
      >
        <h5
          class="u-padding-right-xsmall u-padding-top-xsmal u-padding-left-xsmall u-margin-top-small"
        >
          {{ feature.localesInfo[$i18n.locale] }}
        </h5>
        <ul class="c-list u-margin-top-small row">
          <li
            class="c-list__item u-display-flex es-xs-12 es-sm-6 u-padding-right-xsmall u-padding-left-xsmall u-align-items-center u-justify-content-space-between"
            v-for="(option, j) in feature.options"
            :key="i + '-' + j"
          >
            <span> {{ option.localesInfo[$i18n.locale] }}</span>
            <span>{{ option.value }} {{ option.suffix }}</span>
          </li>
        </ul>
      </div>
      <div class="es-xs-12 es-sm-4 u-padding-xsmall">
        <h5 class="u-margin-top-xsmall u-margin-bottom-small">
          {{ $t("batteryDetail.otherFeatures") }}
        </h5>
        <ul class="c-list">
          <li class="c-list__item">
            <span> {{ $t("batteryDetail.tubeLiquidVelocity") }}</span>
            <span>{{ battery.batteryResultInfo?.tubeLiquidVelocity }}</span>
          </li>
          <li class="c-list__item">
            <span> {{ $t("batteryDetail.tubeVaporVelocity") }}</span>
            <span>{{ battery.batteryResultInfo?.tubeVaporVelocity }}</span>
          </li>
          <li class="c-list__item">
            <span> {{ $t("batteryDetail.inletEnthalpy") }}</span>
            <span>{{ battery.batteryResultInfo?.inletEnthalpy }}</span>
          </li>
          <li class="c-list__item">
            <span> {{ $t("batteryDetail.outletEnthalpy") }}</span>
            <span>{{ battery.batteryResultInfo?.outletEnthalpy }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BatteryFeatures",

  data() {
    return {};
  },
  props: {
    features: {
      default: () => [],
    },
    result: {
      default: () => [],
    },
    battery: {
      default: () => {},
    },
  },
};
</script>

<style></style>
